let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cK7XU")).then(() => parcelRequire('al4ZP'));